
<div class="modal-body" :class="[width, { 'full-height': fullHeight }]">
  <slot></slot>
</div>
